import { AwesomeEvent, ComponentAPI, Value } from '@philips-emr/tws-core';
import { Renderable, RenderEventListener } from '@philips-emr/tws-core/lib/component/types';

import HpmsCustomCardType, { HpmsCustomCardEventListener, HpmsCustomCardMenuRenderEventListener } from '../types/menu-card-type';

export const DYNAMIC_CONTENT_TYPE = 'hpms-custom-card-dynamic-content';
export const ACTION_TYPE = 'hpms-custom-card-action';

export default class HpmsCustomCardAPI extends ComponentAPI<{ hasCollapsed: boolean, background: string }> implements HpmsCustomCardType<Record<string, Value>>, Renderable {
  /** @event */
  @AwesomeEvent
  onDynamicContentRender = new RenderEventListener();

  /** @event */
  @AwesomeEvent
  onCreateOption = new HpmsCustomCardMenuRenderEventListener<Record<string, Value>>();

  /** @event */
  @AwesomeEvent
  onOptionClick = new HpmsCustomCardEventListener<Record<string, Value>>();

  /** @event */
  @AwesomeEvent
  onCreateMenu = new HpmsCustomCardMenuRenderEventListener<Record<string, Value>>();

  /** @event */
  @AwesomeEvent
  onRenderAction = new RenderEventListener();

  setShowActionCollapse(hasCollapsed: boolean): void {
    this.setState({ hasCollapsed });
  }

  setBackground(background: string): void {
    this.setState({ background });
  }

}
